// eslint-disable-next-line max-len
export default typeof window !== 'undefined' && (typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1)
